import React from 'react'
import {Box} from '@fuegokit/react'
import styled from 'styled-components'
import Placeholder from '../../../src/components/Placeholder'
import {
  useRuleBuilderSteps,
  PositionAwareItem,
  RuleDetail,
  range,
  VerticalPositionProvider
} from '../../../src/experimental/RuleBuilder'

const ExampleBox = ({isSelected, onSelect, children, id, ...props}) => {
  // console.log(`isSelected in example box ${id}:`, isSelected)
  return (
    <StyledExampleBox onSelect={onSelect} isSelected={isSelected} {...props}>
      {children}
    </StyledExampleBox>
  )
}

const StyledExampleBox = styled(Box)`
  border: 1px dashed transparent;
  border-color: ${p => (p.isSelected ? 'deeppink' : 'transparent')};
`

const StyledPositionAwareItemExample = () => {
  const [selectedItemId, setSelectedItemId] = React.useState(null)

  const handleItemSelect = itemId => {
    if (selectedItemId === itemId) {
      setSelectedItemId(null)
    } else {
      setSelectedItemId(itemId)
    }
  }

  return (
    <VerticalPositionProvider>
      <Box sx={{display: 'flex', flex: '1 1 100%', flexWrap: 'wrap', maxWidth: '100%', height: '578px'}}>
        <Box sx={{flex: 1}}>
          <Box sx={{display: 'flex', flexDirection: 'column', width: '100%', height: '100%'}}>
            <Box
              sx={{
                border: '1px dashed green',
                p: 3,
                mt: 2,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                height: '100%'
              }}
            >
              {range(2).map((num, index) => {
                return (
                  <PositionAwareItem
                    trackCenterY
                    index={index}
                    key={`${num}-${index}`}
                    id={`my-position-aware-unique-id-${num}-${index}-a`}
                  >
                    <ExampleBox
                      sx={{p: 2}}
                      id={`item-${num}-${index}-c`}
                      isSelected={selectedItemId === `item-${num}-${index}-a`}
                      onSelect={itemId => handleItemSelect(`item-${num}-${index}-a`)}
                    >
                      <Placeholder height={44} label={`${index}-a`} />
                    </ExampleBox>
                  </PositionAwareItem>
                )
              })}
            </Box>
          </Box>
        </Box>
        {/** Right pane */}
        <Box sx={{flex: 1}}>
          <Box sx={{width: '100%', px: 5, height: '100%'}}>
            <RuleDetail headerHeight={0}>
              <Box sx={{minHeight: `100%`}} />
            </RuleDetail>
          </Box>
        </Box>
      </Box>
    </VerticalPositionProvider>
  )
}

export default StyledPositionAwareItemExample
